import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getDivisions, createDivision } from '../api/enterprise';
import CreateDivisionModal from './CreateDivisionModal.tsx';

function Main({ enterpriseId, enterprise, divisions, setDivisions, setSelectedDivisionId, setSelectedDivisionName }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedDivision, setSelectedDivision] = useState('');
  const [showCreateDivision, setShowCreateDivision] = useState(false);

  const handleCreateDivision = async (enterpriseId, name) => {
    try {
      await createDivision(enterpriseId, name);
      const divisionsData = await getDivisions(enterpriseId);
      setDivisions(divisionsData);
      setShowCreateDivision(false);
    } catch (error) {
      console.error('Error creating division:', error);
    }
  };

  const handleDivisionChange = (e) => {
    setSelectedDivision(e.target.value);
  };

  const handleGoToDirectory = () => {
    if (selectedDivision) {
      const selectedDivisionData = divisions.find(division => division.division_id === selectedDivision);
      setSelectedDivisionId(selectedDivision);  // Сохранить ID выбранного подразделения
      setSelectedDivisionName(selectedDivisionData.name); // Сохранить название выбранного подразделения
      localStorage.setItem('selectedDivisionName', selectedDivisionData.name);
      navigate(`/${enterpriseId}/division/${selectedDivision}`);  // Переход на страницу подразделения
    }
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <h1 className="m-0 text-center">{t('select_enterprise_division')}</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="content">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="card card-primary">
                <div className="card-body">
                  {divisions && divisions.length > 0 ? (
                    <div className="form-group">
                      <label>{t('select_division')}</label>
                      <select className="form-control" value={selectedDivision} onChange={handleDivisionChange}>
                        <option value="" disabled>{t('select_division')}</option>
                        {divisions.map((division) => (
                          <option key={division.division_id} value={division.division_id}>
                            {division.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : (
                    <button className="btn btn-primary btn-block" onClick={() => setShowCreateDivision(true)}>
                      {t('create_division')}
                    </button>
                  )}
                  <CreateDivisionModal
                    show={showCreateDivision}
                    handleClose={() => setShowCreateDivision(false)}
                    handleCreate={handleCreateDivision}
                    enterpriseId={enterpriseId}
                  />
                  <div className="mt-3 text-center">
                    <button className="btn btn-secondary" onClick={handleGoToDirectory}>
                      {t('go_to_directory')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> 
      </div>
    </div>
  );
}

export default Main;
